export var Origin;
(function (Origin) {
    Origin["AreaReport"] = "AREA_REPORT";
    Origin["AussieHomes"] = "AUSSIE_HOMES";
    Origin["BorrowingPower"] = "BORROWING_POWER";
    Origin["PropertyReport"] = "PROPERTY_REPORT";
    Origin["Toolbox"] = "TOOLBOX";
    Origin["LAMForm"] = "LAM_FORM";
    Origin["SignUp"] = "SIGN_UP";
    Origin["NewHomeLoan"] = "NEW_HOME_LOAN";
    Origin["Refinance"] = "REFINANCE";
    Origin["Blog"] = "BLOG";
    Origin["StampDutyCalculator"] = "STAMP_DUTY_CALCULATOR";
    Origin["AppointmentBooking"] = "APPOINTMENT_BOOKING";
    Origin["Invite"] = "INVITE";
    Origin["Chat"] = "CHAT";
    Origin["SelfGen"] = "SELF_GEN";
    Origin["CreditScore"] = "CREDIT_SCORE";
    Origin["FixedRateExpiry"] = "FIXED_RATE_EXPIRY";
    Origin["AffiliateLead"] = "AFFILIATE_LEAD";
    Origin["MarketingOther"] = "MARKETING_OTHER";
    Origin["CarLoan"] = "CAR_LOAN";
    Origin["BusinessLoanAssetFinance"] = "BUSINESS_LOAN_ASSET_FINANCE";
    Origin["BusinessLoanCommercial"] = "BUSINESS_LOAN_COMMERCIAL";
    Origin["Insurance"] = "INSURANCE";
})(Origin || (Origin = {}));
//# sourceMappingURL=index.js.map